import { Form, Button, InputGroup, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState } from 'react';
import { setIsLoading } from '../general/actions';
import AlertModal from '../general/alertModal';

function DepartmentsList(props) {
    const { setIsLoading } = props;

    const [items, setItems] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');

    const getList = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('/departments/current-company-user/');
            setItems(response.data);
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalType('danger');
            setAlertModalMsg(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => { if (!items.length) getList(); }, []);

    const filtered = items.filter(item =>
        (item.name?.toLowerCase().includes(searchText.toLowerCase())) ||
        (String(item.ext_id).includes(searchText))
    );

    return (
        <>
            <div className="order-section">
                <div className="order-section-header" style={{ justifyContent: 'space-between' }}>
                    <span><i className="fa fa-building-o" /> Centros de costos</span>
                    <Button size="sm" variant="primary" onClick={() => props.setIsCreation(true)}>
                        <i className="fa fa-plus" /> Crear
                    </Button>
                </div>
                <div className="order-section-body" style={{ paddingBottom: 0 }}>
                    <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                        <InputGroup style={{ maxWidth: 300 }}>
                            <InputGroup.Text style={{ background: 'var(--abi-bg)', border: '1px solid var(--abi-border)', borderRight: 'none', fontSize: 12 }}>
                                <i className="fa fa-search" style={{ color: 'var(--abi-muted)' }} />
                            </InputGroup.Text>
                            <Form.Control
                                placeholder="Buscar centro de costos…"
                                size="sm" value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{ borderLeft: 'none' }}
                            />
                            {searchText && (
                                <Button size="sm" variant="outline-secondary" onClick={() => setSearchText('')}>
                                    <i className="fa fa-times" />
                                </Button>
                            )}
                        </InputGroup>
                        <span className="report-count" style={{ alignSelf: 'center' }}>
                            <strong>{filtered.length}</strong> de <strong>{items.length}</strong>
                        </span>
                    </div>
                </div>

                {filtered.length > 0 && (
                    <table className="report-table mb-0" style={{ width: '100%', borderRadius: 0, border: 'none' }}>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Centro de Costos</th>
                                <th>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map(item => (
                                <tr key={'dep-' + item.id}>
                                    <td style={{ fontWeight: 700, color: 'var(--abi-primary)', fontSize: 12 }}>#{item.id}</td>
                                    <td style={{ fontWeight: 600 }}>{item.name}</td>
                                    <td>
                                        <span className="report-status-badge" style={
                                            item.is_active
                                                ? { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }
                                                : { background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }
                                        }>
                                            {item.is_active ? 'Activo' : 'Inactivo'}
                                        </span>
                                    </td>
                                    <td>
                                        <button className="report-icon-btn" title="Editar" onClick={() => props.setEditData(item)}>
                                            <i className="fa fa-pencil" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(DepartmentsList);
